import { useMemo } from 'react';

import { useAnalyticsContext } from '../BricksProvider';

/**
 * This wrapper hook is added because not every FE app is onboarded to use observability, and observability
 * expects `globalObservability` to have been initialized when `trackJourneyEvent`. Thus, within the
 * scope of `bricks`, we catch any errors of the real `trackJourneyEvent call.
 * Additionally this hook allows us to use the client's version of observability for cases like when we need to use mobile's version of trackJourneyEvent
 * @returns functions trackJourneyEvent
 */
export const useObservabilitySafe = (): {
  trackJourneyEvent: (...args: Parameters<typeof trackJourneyEvent>) => void;
} => {
  // This allows use to use the client's version of trackJourneyEvent
  const { useObservability } = useAnalyticsContext();
  const { trackJourneyEvent } = useObservability();

  return useMemo(
    () => ({
      trackJourneyEvent: (...args: Parameters<typeof trackJourneyEvent>) => {
        try {
          trackJourneyEvent(...args);
        } catch {} // eslint-disable-line no-empty
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
};
